import { defineStore } from 'pinia'
import type { CurrentUserData, IUserStore } from '~/composables/account/interface'
const STORE_NAME = 'userData'

export const useCurrentUserStore = defineStore(STORE_NAME, {
  state: (): CurrentUserData => ({
    data: {
      id: '',
      email: '',
      avatar: 1,
      birthday: '',
      fullname: '',
      contactName: '',
      gptoken: '',
      phone: '',
      token: '',
      username: '',
      withdraw_wallet_address: '',
      wallet: {
        balance: 0
      }
    }
  }),
  persist: true,
  actions: {
    setFullname(fullname: string) {
      this.data.fullname = fullname
      this.data.update_fullname_count = 1
    },
    setEmail(email: string) {
      this.data.email = email
    },
    setPhone(phone: string) {
      this.data.phone = phone
    },
    setCurrentUser(user: IUserStore) {
      this.data = user
    },
    getWalletUser(): number {
      return this.data?.wallet?.balance ?? 0
    },
    setWalletAddress(data: string) {
      this.data.withdraw_wallet_address = data
    }
  }
})
